var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('i',{staticClass:"nav-menu dib",on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }